import React from "react";
import { Link } from "react-router-dom";
import DownloadAppBanner from "./DownloadAppBanner";
import "./DownloadAppBanner.css";

/**
 * Full-page view shown when user hits /cart, /checkout, /my-order, /order-details.
 * Shows the download app banner and a link back to home.
 */
export default function DownloadAppPage() {
  return (
    <div className="container py-5" style={{ maxWidth: 560, marginTop: 100 }}>
      <DownloadAppBanner className="mb-4" />
      <p className="text-center mb-0">
        <Link to="/" className="btn btn-outline-secondary">
          Back to Home
        </Link>
      </p>
    </div>
  );
}
